// import React, { useState, useRef, useEffect } from "react";


// function CreatePurchaseOrders() {


//   return (
//     <>
//      <div>
//         Hello
//      </div>
//     </>
//   );
// }

// export default CreatePurchaseOrders;


import React, { useEffect, useState } from "react";
import axios from "axios";

import { Link, useNavigate } from "react-router-dom";
import { toastError, toastSuccess } from "../../../common/Toast";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import Loader from "../../../components/Loader/Loader";
import config from "../../../config/config";
import Select from "react-select";
import NewWorkModal from "../../../components/Modal/NewWorkModal";


import { uploadAWS } from "../../../common/AWSHelper";
import {
    ALREADY_EXIST,
    AWS_IMAGE_FOLDER_SALES,
    ERROR_MESSAGE,
    SUCCESS_MESSAGE,
} from "../../../common/Constant";

const CreatePurchaseOrders = (props) => {
    let navigate = useNavigate();

    const [loading, setLoading] = useState(false);


    const selectStyles = {
        control: (provided) => ({
            ...provided,
            width: "100%",
            height: "40px",
            position: "relative",
        }), // dropdown input css
        menu: () => ({
            boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
            position: "absolute",
            background: "#f8f8f8",
            width: "100%",
            zIndex: 99,
        }), // dropdown menu css
    };



    return (
        <>

            <Loader loading={loading} />
            <Sidebar />
            <div className="page-wrapper cardhead">
                <div className="content container-fluid">
                    <div className="page-header"
                        style={
                            {
                                position: "fixed",
                                top: "2px",
                                zIndex: "999"
                            }
                        }
                    >
                        <div className="row" style={{ marginTop: "5px" }}>
                            <h3 className="page-title">Receiving </h3>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                                    <Link to="/dashboard">Dashboard</Link>
                                </li>
                                <li className="breadcrumb-item">
                                    <Link to="/Receiving">Receiving</Link>
                                </li>
                                <li className="breadcrumb-item">
                                    <Link>Create Purchase Order
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="btn-group ms-2 mb-2">
                        <button type="button" className="btn btn-sm btn-outline-dark d-none">
                            More
                        </button>
                        <button
                            type="button"
                            className="btn btn-sm btn-outline-dark dropdown-toggle me-1"
                            data-bs-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            style={{ borderRadius: "5px" }}
                        >
                            More &nbsp;
                            {/* <span className="sr-only">Toggle Dropdown</span> */}
                        </button>
                        <div className="dropdown-menu">
                            <li>
                                <Link class="dropdown-item" to="/sales">
                                    New Sale
                                </Link>

                            </li>
                            <li>

                                <Link class="dropdown-item"
                                    to="/workorders"
                                    // title="Cleanup old Customers"
                                    data-bs-target="#NewWorkModal"
                                    data-bs-toggle="modal"
                                    onClick={() => navigate('/workorders')}
                                >

                                    New Work Order
                                </Link>

                            </li>
                            <li>

                                <Link class="dropdown-item" to="/create-purchase-orders">
                                    New Purchase Order
                                </Link>

                            </li>
                            <li>

                                <Link class="dropdown-item" to="/manage-customers">
                                    New Customer
                                </Link>

                            </li>
                            <li>

                                <Link
                                    to="/manage-items"
                                    className="dropdown-item"

                                >
                                    New Item
                                </Link>

                            </li>
                        </div>
                    </div>
                    <form>
                        {/* {divs} */}
                        <div className="card">
                            <div className="card-body">
                                <div className="col-sm-12 mb-2">
                                    <div className="row">
                                        <label className="col-form-label col-md-3 form-label">
                                            Suppliers :
                                        </label>
                                        <div className="col-md-9">
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm 
                                                    }`}
                                                placeholder="Suppliers"

                                                // onChange={handleChange}
                                                id="Suppliers"
                                                name="Suppliers"
                                            />

                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12 mb-2">
                                    <div className="row">
                                        <label className="col-form-label col-md-3 form-label">
                                            Category:
                                        </label>
                                        <div className="col-md-9">
                                            <Select
                                                backspaceRemovesValue={false}
                                                controlShouldRenderValue={true}
                                                hideSelectedOptions={true}
                                                isClearable={true}
                                                // onChange={setSelectedTitle}
                                                // options={title}
                                                placeholder="Category"
                                                styles={selectStyles}
                                                // value={selectedTitle}
                                                id="Category"
                                                name="Category"
                                                className="custom-search-select"
                                            />

                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12 mb-2">
                                    <div className="row">
                                        <label className="col-form-label col-md-3 form-label">
                                            Criteria For Purchase Order:
                                        </label>
                                        <div className="col-md-9">
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm  
                                                    }`}
                                                // onChange={handleChange}
                                                placeholder="Criteria For Purchase Order"

                                                id="CriteriaForPurchaseOrder"
                                                name="CriteriaForPurchaseOrder"
                                            />

                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12 mb-2">
                                    <div className="form-group row">
                                        <label className="col-form-label col-md-3 form-label">
                                            Clear Current Items In Cart:                                        </label>
                                        <div className="col-md-9">
                                            <input
                                                className="form-check-input"
                                                style={{ width: "1.5em", height: "1.5em" }}
                                                type="checkbox"
                                                id="ClearCurrentItemsInCart"
                                                name="ClearCurrentItemsInCart"
                                            // onChange={handleChange}
                                            // onInput={handleSelectOverrideDefaultTaxForSale}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <button
                                    type="submit"
                                    className="btn btn-sm btn-primary mb-3 me-3"
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <NewWorkModal />
        </>
    );
};

export default CreatePurchaseOrders;


